import { render, staticRenderFns } from "./readingcreatedialog.vue?vue&type=template&id=2128eb92&scoped=true"
import script from "./readingcreatedialog.vue?vue&type=script&lang=js"
export * from "./readingcreatedialog.vue?vue&type=script&lang=js"
import style0 from "./readingcreatedialog.vue?vue&type=style&index=0&id=2128eb92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/ad/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2128eb92",
  null
  
)

export default component.exports